import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { EventContext } from '@/redux/modules/analytics';
import { CompleteAccountModalContext, ModalContext } from '@/redux/modules/modal';
import { getFirstSalesHistoryItemId, getSlugItemId } from '@/redux/modules/priceResults/priceResults.selectors';
import { getIdFromPath, isItemPage, isPriceGuidePage, isPriceResultsPage } from '@/utils/urls';

/**
 * useOnTheHuntModalContext
 * returns object with necessary information to display an exit intent modal header
 * @returns ModalContext
 */
const useOnTheHuntModalContext = (): ModalContext => {
    const { pathname, search } = useLocation();
    const isOnItemPage = isItemPage(pathname) || isPriceGuidePage(pathname);
    const itemId = getIdFromPath(pathname);

    // price result info
    const isOnPriceResultPage = isPriceResultsPage(pathname);
    const slugItemId = useAppSelector(getSlugItemId);
    const salesHistoryItemId = useAppSelector(getFirstSalesHistoryItemId);
    const urlItemId = Number(search.match(/itemId=(\d+)/)?.[1]);

    if (isOnItemPage) {
        return {
            eventContext: EventContext.exitIntentModal,
            id: itemId,
            itemId,
            type: CompleteAccountModalContext.ExitIntentItem,
        };
    }

    if (isOnPriceResultPage) {
        const priceResultItemId = urlItemId || slugItemId || salesHistoryItemId;

        return {
            eventContext: EventContext.exitIntentModal,
            id: priceResultItemId,
            itemId: priceResultItemId,
            type: CompleteAccountModalContext.ExitIntentPriceResult,
        };
    }

    return {
        eventContext: EventContext.exitIntentModal,
        id: 0,
        type: CompleteAccountModalContext.ExitIntentSearch,
    };
};

export default useOnTheHuntModalContext;
